<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-header bg-primary text-white">Campos</div>
            <div class="card-body table-responsive">
                <table class="table table-hover table-sm">
                    <thead class="font-weight-bold">
                        <tr>
                            <td>#</td>
                            <td>Nombre</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr @click="select(field)" v-for="(field, i) in getFields" :key="field.id">
                            <td>{{i+1}}</td>
                            <td>{{field.name}} <span v-if="field.selected">✅</span></td>
                        </tr>
                    </tbody>
                </table>
                <button class="btn btn-primary float-right" :class="{'btn-secondary':addField}" @click.prevent="addField = !addField">{{addField ? 'Cancelar' : 'Agregar campo'}}</button>
            </div>
        </div>
        <add-field v-if="addField"></add-field>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import AddField from './AddField';

export default {
    name: "Fields",
    components: {AddField},
    created(){this.fetchFields()},
    data: () => ({
        addField: false,
    }),
    computed: mapGetters(['getFields', 'getField']),
    methods: {
        ...mapActions(['fetchFields', 'selectField']),
        select(item){
            this.selectField(item)
        }
    },
}
</script>

<style scoped>
    .table td {
        cursor: pointer;
    }
</style>